import React, { useState } from "react";
import QuickView from "./QuickView";
import "./RoutineProducts.css";
import { useCurrency } from "../../Context/CurrencyContext";

const products = [
  {
    id: 1,
    brand: "MOKOSH",
    title: "Figa smoothing face cream",
    price: 650,
    priceValue: 650,
    image:
      "https://wonder-theme-beauty.myshopify.com/cdn/shop/products/mokosh_eb6f0013-4fcc-4f5e-8693-7200be74e429.jpg?v=1661021258&width=1000",
    button: "CHOOSE OPTION",
  },
  {
    id: 2,
    brand: "MOKOSH",
    title: "Active toning essence",
    price: 550,
    priceValue: 550,
    image:
      "https://wonder-theme-beauty.myshopify.com/cdn/shop/products/esencja-Roza-PL.jpg?v=1660223483&width=1000",
    button: "ADD TO CART",
  },
  {
    id: 3,
    brand: "BKIND",
    title: "Algae Peel-Off Mask",
    price: 860,
    priceValue: 860,
    image:
      "https://wonder-theme-beauty.myshopify.com/cdn/shop/products/bkind-floral-face-2_718634ed-72d4-47b3-98aa-ab26bbc66519.jpg?v=1661113363&width=1000",
    button: "ADD TO CART",
  },
];

const RoutineProducts = () => {
  const { formatPrice } = useCurrency();
  const [openQuickView, setOpenQuickView] = useState(false);

  return (
    <>
      <div className="routine-products">
        <p className="product-count">3 products</p>

        <div className="product-grid">
          {products.map((item) => (
            <div className="product-card" key={item.id}>
              <div className="image-wrapper">
                <img src={item.image} alt={item.title} />

                <button
                  className="hover-btn"
                  onClick={() =>
                    item.button === "CHOOSE OPTION"
                      ? setOpenQuickView(true)
                      : null
                  }
                >
                  {item.button}
                </button>
              </div>

              <p className="brand">{item.brand}</p>
              <h4>{item.title}</h4>
              <p className="price">{formatPrice(item.price)}</p>
            </div>
          ))}
        </div>
      </div>

      <QuickView
        open={openQuickView}
        onClose={() => setOpenQuickView(false)}
      />
    </>
  );
};

export default RoutineProducts;